<template>
  <div class="proWhy reveal px-10vw">
    <div class="psTitle">
        Why MIS LYNX?
    </div>
    <ul>
        <li v-for="item in items" :key="item.title">
            <img :src="item.img" :title="item.title" />
            <h5>{{item.title}}</h5>
            <p>{{item.summary}}</p>
        </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        items:[
            {img:"img/icons/adaptive_placement.png",title:"Adaptive Placement for Surgical Simplicity",summary:"MIS LYNX’s distinctive design promotes flexibility and reliability in implant procedures."},
            {img:"img/icons/single_use.png",title:"Single-Use Drills with Every Implant for Surgical Efficiency",summary:"MIS LYNX includes sharp and sterile drills in every package, providing a simplified drilling procedure while maintaining strict hygiene protocols."},
            {img:"img/icons/versatility.png",title:"Restorative Versatility for Esthetics Excellence",summary:"MIS LYNX offers a wide range of prosthetics, reducing workflow complexity by streamlining the process and empowering flexible, efficient, and esthetic results."}        
        ]
    };
  },
  props: {
    sectionData:{}
  },
  computed: {
    ...mapGetters(["localeString"]),

    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }
  },
  methods: 
  {
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),
  }
};
</script>

<style scoped>

    .proWhy
    {
        width: 100%;
        min-height: 200px;
        background: #48494b;
        color: #fff;
        padding: 7vw;
    }
    .proWhy .psTitle
    {
        color: #fff;
        width: 100%;
    }
    .proWhy ul
    {
        padding-top: 40px;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 6vw;
    }
    .proWhy ul li
    {
        text-align:left;
        background:transparent; /* keep minimalist; add border or bg if desired */
    }
    .proWhy ul li img
    {
        height: 50px;
        width: auto;
    }
    .proWhy ul li h5
    {
        padding-top: 10px;
        font-size: 24px;
        color: #fff;
        width: 100% !important;
    }
    .proWhy ul li p
    {
        padding-top: 20px;
        font-size: 16px;
        color: #bfbfbf;
    }


    @media (hover: hover) {
    }

    @media screen and (max-width: 815px)
    {
        .proWhy
        {
            padding: 16vw 12vw;
        }
        .proWhy ul
        {
            grid-template-columns: 1fr;

        }
    }


    @media only screen and (min-width:2000px)
    {
    }
</style>
